import React, { useEffect, memo } from 'react';
import classes from './NavList.module.css';
import { NavLink, useLocation } from 'react-router-dom';
import { Donut } from 'react-awesome-shapes/dist/shapes/donut';
import { Diamond } from 'react-awesome-shapes/dist/shapes/diamond';
// import { Circle } from "react-awesome-shapes/dist/shapes/circle";
// import { Discord } from "../UI/Socail/Discord";
const NavList = props => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
  }, []);
  //assigning location variable
  const location = useLocation();

  //destructuring pathname from location
  const { pathname } = location;

  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split('/');

  return (
    <>
      <div className={classes.colorfix}>
        <div className={classes.navbox}>
          <Donut
            className={classes.float1}
            color="#f43f5e"
            size="180px"
            width={['40px', '40px', '60px', '60px']}
            zIndex={0}
          />
          <Donut
            className={classes.float2}
            color="#f4f35e"
            size="180px"
            width={['40px', '40px', '60px', '60px']}
            zIndex={0}
          />
          <Diamond
            className={classes.float3}
            color="linear-gradient(135deg, #93c5fd, #3b82f6)"
            size="100px"
            zIndex={0}
          />
          <Diamond
            className={classes.float4}
            color="linear-gradient(135deg, deeppink, pink)"
            size="100px"
            zIndex={0}
          />

          <ul className={classes['list-items']}>
            <li className={classes.home}>
              <NavLink
                to="/"
                onClick={props.onClick}
                href="/"
                className={
                  splitLocation[1] === '' ? classes.active : classes.nav_links
                }
              >
                Home
              </NavLink>
            </li>
            <li className={classes.about}>
              <NavLink
                to="/about"
                onClick={props.onClick}
                href="/"
                className={
                  splitLocation[1] === 'about'
                    ? classes.active
                    : classes.nav_links
                }
              >
                About
              </NavLink>
            </li>
            <li className={classes.projects}>
              <NavLink
                to="/projects"
                onClick={props.onClick}
                href="/"
                className={
                  splitLocation[1] === 'projects'
                    ? classes.active
                    : classes.nav_links
                }
              >
                Projects
              </NavLink>
            </li>
            <li className={classes.experience}>
              <NavLink
                to="/experience"
                onClick={props.onClick}
                href="/"
                className={
                  splitLocation[1] === 'experience'
                    ? classes.active
                    : classes.nav_links
                }
              >
                Experience
              </NavLink>
            </li>
            <li className={classes.contact}>
              <NavLink
                to="/contact"
                onClick={props.onClick}
                href="/"
                className={
                  splitLocation[1] === 'contact'
                    ? classes.active
                    : classes.nav_links
                }
              >
                Contact
              </NavLink>
            </li>
          </ul>
        </div>
        {/* <Discord /> */}
      </div>
    </>
  );
};

export default memo(NavList);
